import { useIntl } from '@/intl'
import {
  PartyCompositionFilter,
} from '@/scopes/products/pages/components/HeroSection/Reviews/Filters/PartyCompositionFilter'
import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Button, Sheet, Typography, useBreakpoints } from '@sunwebgroup/ui-components/uds'
import React, { useState } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
    background-color: ${tok('primitives_color_neutral_0')};
    display: flex;
    justify-content: end;
    align-items: center;
    padding: ${space('primitives_space_12')} ${space('primitives_space_16')};
    gap: ${space('primitives_space_12')};
    border-bottom: ${tokPx('semantics_dividers_tickness')} solid ${tok('primitives_color_neutral_100')};
    position: sticky;
    top: 0;
    z-index: 99;
`

const SheetContent = styled(Sheet.Content)`
  padding: ${tokPx('primitives_space_16')};
`

const PartyCompositionFilterLabel = styled.div`
  margin-bottom: ${space('primitives_space_4')};
`

const SheetFooter = styled(Sheet.Footer)`
  border-top: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_dividers_color')};
`

const FooterWrapper = styled.div`
  position: sticky;
  position: -webkit-sticky;
  bottom: 0;
  background-color: ${tok('semantics_views_background_color')};
  z-index: 1;
  padding: ${space('primitives_space_12')} 0;
`

export function MobileFilters() {
  const { isDesktop } = useBreakpoints()
  const [showFilters, setShowFilters] = useState(false)
  const intl = useIntl()

  if (isDesktop) {
    return null
  }

  return (
    <Wrapper>
      <Sheet.Root open={showFilters} onOpenChange={setShowFilters}>
        <Sheet.Trigger>
          <Button $size="S" $type="primary">
            {intl.formatMessage({ id: 'reviews_change_filters' })}
          </Button>
        </Sheet.Trigger>
        <Sheet.Body side="bottom">
          <Sheet.Header
            closeLabel={intl.formatMessage({ id: 'close' })}
            titleLabel="Filters"
          />
          <SheetContent>
            <PartyCompositionFilterLabel>
              <Typography $variant="body-m-regular-tight">
                {intl.formatMessage({ id: 'reviews_party_composition_label' })}
              </Typography>
            </PartyCompositionFilterLabel>
            <PartyCompositionFilter />
          </SheetContent>
          <SheetFooter>
            <FooterWrapper>
              <Button $type="primary" $fullWidth onClick={() => setShowFilters(false)}>
                {intl.formatMessage({ id: 'reviews_change_filters' })}
              </Button>
            </FooterWrapper>
          </SheetFooter>
        </Sheet.Body>
      </Sheet.Root>
    </Wrapper>
  )
}
